import { useState as v, useEffect as x } from "react";
import { useSetAtom as t } from "jotai";
import { parseDate as B } from "@amenitiz/design-system";
import { useBookingData as z } from "./index24.mjs";
import { setConfigAtom as F, ViewLayout as G } from "./index13.mjs";
import { setCurrentStepAtom as J } from "./index25.mjs";
import { arrivalDateAtom as K, departureDateAtom as M, totalAdultsAtom as O, totalChildrenAtom as Q, promoCodeAtom as T } from "./index26.mjs";
const et = ({
  locale: r,
  maxAdults: s,
  maxChildren: n,
  isFullAddressRequired: a,
  vgsEnvironment: i,
  googleMapsApiKey: m,
  hotelId: c,
  hotelName: l,
  hotelEmail: g,
  propertyType: u,
  propertySize: d,
  subscriptionPlan: p,
  regions: f,
  hasPromocodeEnabled: S = !1,
  clientBookingToken: C,
  vgsVaultId: A
}, D = G.SIDE_PANEL) => {
  const [H, R] = v(!1), [U, V] = v(!1), h = t(K), k = t(M), b = t(O), E = t(Q), L = t(T), P = t(J), j = z(), e = t(F);
  return x(() => {
    const o = new URLSearchParams(window.location.search), _ = o.get("start_date"), w = o.get("end_date"), I = o.get("adults"), N = o.get("children"), q = o.get("promoCode"), y = o.get("google_hotel");
    _ && w && I && N && (h(B(_)), k(B(w)), b(Number(I)), E(Number(N)), L(q || ""), P(1), V(!0)), e({
      googleHotelLink: y || ""
    });
  }, [
    b,
    h,
    E,
    P,
    k,
    L,
    e
  ]), x(() => {
    e({
      locale: r,
      maxAdults: s.toString(),
      maxChildren: n.toString(),
      isFullAddressRequired: a.toString(),
      vgsEnvironment: i || "sandbox",
      googleMapsApiKey: m || "",
      hotelId: c || "",
      hotelName: l || "",
      hotelEmail: g || "",
      propertyType: u || "",
      propertySize: d || "",
      subscriptionPlan: p || "",
      hasPromocodeEnabled: S.toString(),
      regions: f,
      viewLayout: D,
      clientBookingToken: C || "",
      vgsVaultId: A || ""
    }), R(!0);
  }, [
    r,
    s,
    n,
    e,
    a,
    i,
    m,
    c,
    l,
    g,
    u,
    d,
    p,
    S,
    f,
    D,
    C,
    A
  ]), { isConfigSet: H, isSearchCriteriaSet: U, bookingData: j };
};
export {
  et as useSetupBookingEngine
};
